import React from 'react';
export function ClosingCTA() {
  return <section className="py-8 px-4 bg-brand-navy text-white" data-id="element-41">
      <div className="max-w-3xl mx-auto text-center" data-id="element-42">
        <h2 className="text-2xl md:text-4xl font-display font-bold uppercase leading-tight mb-5" data-id="element-43">
          Hay <span className="text-brand-yellow" data-id="element-44">dos tipos</span> de docentes
          de Acuicultura.
        </h2>

        <div className="text-left space-y-3 text-sm md:text-base text-white/90 font-medium leading-snug" data-id="element-45">
          <p data-id="element-46">
            Los que improvisan cada semana, buscan material el domingo a la
            noche, usan lo que encuentran aunque no sea preciso y llegan al
            lunes sin estar seguros de lo que van a enseñar.
          </p>
          <p className="font-bold text-white text-base md:text-lg" data-id="element-47">
            Y los que tienen un sistema.
          </p>
          <p data-id="element-48">
            La diferencia no es el conocimiento técnico. La diferencia es tener
            o no tener la arquitectura didáctica que convierte ese conocimiento
            en aprendizaje real, medible y aplicable.
          </p>
          <p data-id="element-49">
            Por <span className="text-brand-yellow font-bold" data-id="element-50">USD 19,90</span> —
            menos de lo que cuesta un par de libros técnicos que nadie va a
            terminar de leer — tenés todo lo que necesitás para ser el segundo
            tipo de docente.
          </p>
          <p data-id="element-51">
            Por <span className="text-brand-yellow font-bold" data-id="element-52">USD 23,90</span> —
            cuatro dólares más — tenés además el arsenal completo para llevar a
            tus mejores alumnos a un nivel que ningún otro material del sector
            puede ofrecer.
          </p>
          <p className="italic text-center pt-2" data-id="element-53">
            El tipo de docente que sus alumnos recuerdan. El tipo que sus
            colegas le preguntan qué curso hizo. El tipo que forma técnicos que
            el sector contrata antes de graduarse.
          </p>
        </div>
      </div>
    </section>;
}